import React, { useState, useEffect, Suspense, useRef } from 'react'
import classes from "./DeviceManager.module.css";
import DeviceLoadingGrid from '../GridList/DeviceLoadingGrid';
import { Await, useNavigate } from 'react-router-dom';
import UseDateFormat from '../hooks/UseDateFormat';
import GetAllPagedDevices from '../../Pages/AllSites/GetAllPagedDevices';
import { useDispatch, useSelector } from 'react-redux';
import DataManager from '../../hooks/DataManager';
import Button1 from '../UI/Button/Button1';
import { addSitesToGroup, getAllSitesAPI, getGroups, inviteUser } from '../../Api Methods/Api';
import DevicesList from '../GridList/DevicesList';
import Modal from '../../components/Modal/Modal';
import check from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/check.png'
import fail from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/cross.png'
import SelectRoleForm from '../forms/SelectRoleForm';
import loading from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/loading.png'
import { Button } from 'primereact/button';
import AllSitesSearchBar from '../../Pages/AllSites/allSitesSearchBar';
import { serviceActions } from '../../store/service-Slice';
import { ca } from 'date-fns/locale';

const DeviceManager = ({ client, token, companyName, aiQuery, getAllDevices }) => {

    const dataManager = new DataManager();
    const [groups, setGroups] = useState([])
    const _companyName = useSelector(state => state.auth.companyName);
    const userID = useSelector(state => state.auth.userID);
    const [isloading, setIsLoading] = useState(true)
    const [userRole, setUserRole] = useState();
    const [showMassSettings, setShowMassSettings] = useState(false)

    const apiData = {
        token,
        client
    }

    const [groupMode, setGroupMode] = useState(dataManager.getItem('isGroupMode'));
    const addAccessMode = dataManager.getItem('isAddAccessMode')

    const ModalDialog = useRef();
    const [title, setTitle] = useState('');
    const [modalComponent, setModalComponent] = useState();

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const service = useSelector(state => state.service);

    //Filters
    const [active, setActive] = useState(service.active)
    const [online, setOnline] = useState(service.online)
    const [offline, setOffline] = useState(service.offline)
    const [deviceTag, setDeviceTag] = useState(service.deviceTag)
    const [cloudController, setCloudController] = useState(service.cloudController)
    const [davantis, setDavantis] = useState(service.davantis)
    const [g2cc, setG2cc] = useState(service.g2cc)
    const [ESP, setESP] = useState(service.ESP)
    const [RPi, setRPi] = useState(service.RPi)
    const [groupName, setGroupName] = useState(service.groupName)
    const [includeSubgroups, setIncludeSubgroups] = useState(service.includeSubgroups)
    const [noTag, setNoTag] = useState(service.noTag)
    const [searchTerm, setSearchTerm] = useState(service.searchTerm)
    const [noUsers, setNoUsers] = useState(service.noUsers)
    const [liveViewStatus, setLiveViewStatus] = useState(service.liveViewStatus)
    const [scheduleOnly, setScheduleOnly] = useState(service.scheduleOnly)
    const [hasAjax, setHasAjax] = useState(service.hasAjax)
    const [hasHik, setHasHik] = useState(service.hasHik)
    const [hasAIBOX, setHasAIBOX] = useState(service.hasAIBOX)
    const [hasDahua, setHasDahua] = useState(service.hasDahua)
    const [hasPadlock, setHasPadlock] = useState(service.hasPadlock)
    const [hasKeybox, setHasKeybox] = useState(service.hasKeybox)
    const [hasGateway, setHasGateway] = useState(service.hasGateway)
    const [hasSigfox, setHasSigfox] = useState(service.hasSigfox)
    const [hasIndSigfox, setHasIndSigfox] = useState(service.hasIndSigfox)
    const [hasEfento, setHasEfento] = useState(service.hasEfento)
    const [hasSchedules, setHasSchedules] = useState(service.hasSchedules)
    const [hasTempSchedules, setHasTempSchedules] = useState(service.hasTempSchedules)
    const [activePinCount, setActivePinCount] = useState(service.activePinCount)
    const [ruleV2Owner, setRuleV2Owner] = useState(service.ruleV2Owner)
    const [ruleV2Parent, setRuleV2Parent] = useState(service.ruleV2Parent)
    const [ruleV2Affected, setRuleV2Affected] = useState(service.ruleV2Affected)
    const [connectionIssues, setConnectionIssues] = useState(service.connectionIssues)
    const [hasCamerasLinked, setHasCamerasLinked] = useState(service.hasCamerasLinked)

    //Sorts
    const [sortAsc, setSortAsc] = useState(service.sortAsc) //descending
    const [sUserCount, setSUserCount] = useState(service.sUserCount)
    const [sCreated, setSCreated] = useState(service.sCreated) //active by default
    const [sFirmware, setSFirmware] = useState(service.sFirmware)
    const [sName, setSName] = useState(service.sName)
    const [sCameraCount, setSCameraCount] = useState(service.sCameraCount)

    const [totalPages, setTotalPages] = useState([])
    const [resultCount, setResultCount] = useState(0)
    const [totalDevices, setTotalDevices] = useState([])
    const [pageOffset, setPageOffset] = useState(0)
    const [pageFetchedIndex, setPageFetchedIndex] = useState(1)
    const [pageSize, setPageSize] = useState(dataManager.getItem('pageSize'))
    const [update, setUpdate] = useState(0)
    const [submit, setSubmit] = useState(0)

    const [filteredData, setFilteredData] = useState([]) //Will be from cache eventually

    const HandleShowModal = () => {
        ModalDialog.current.open();
    };

    const HandleCloseModal = () => {
        ModalDialog.current.close();
    };

    const GetGroups = async () => {
        try {
            const listOptions = await getGroups(apiData, dispatch);
            console.log(listOptions);
            setGroups(listOptions || []);
        } catch (error) {
            console.error('Failed to fetch groups:', error);
            setGroups([]);
        }
    }

    useEffect(() => {
        GetGroups();
    }, [])

    const GetAllSites = async (body) => {
        setIsLoading(true)
        const response = await getAllSitesAPI(apiData, body, dispatch)
        setResultCount(response.data[0][0].totalCount)
        setFilteredData(response.data[1])
        setTotalPages(Math.ceil(response.data[0][0].totalCount / pageSize));
        setIsLoading(false)

        console.log(response.data[1])
    }
   

    useEffect(() => {
        const offset = pageSize * (pageFetchedIndex -1); 
        setPageOffset(offset);
    
        let body = {
            "active": Number(active),
            "pageSize": Number(pageSize),
            "pageOffset": Number(offset),
            "online": Number(online),
            "offline": Number(offline), 
            "deviceTag": deviceTag,
            "cloudController": Number(cloudController),
            "davantis": Number(davantis),
            "g2cc": Number(g2cc),
            "ESP": Number(ESP),
            "RPi": Number(RPi),
            "groupName": groupName,
            "includeSubgroups": Number(includeSubgroups),
            "noTag": Number(noTag),
            "searchTerm": searchTerm,
            "noUsers": Number(noUsers),
            "liveViewStatus": Number(liveViewStatus), 
            "scheduleOnly": Number(scheduleOnly),
            "hasAjax": Number(hasAjax),
            "hasHik": Number(hasHik),
            "hasAIBOX": Number(hasAIBOX),
            "hasDahua": Number(hasDahua),
            "hasPadlock": Number(hasPadlock), 
            "hasKeybox": Number(hasKeybox),
            "hasGateway": Number(hasGateway),
            "hasSigfox": Number(hasSigfox), 
            "hasIndSigfox": Number(hasIndSigfox),
            "hasEfento": Number(hasEfento),
            "hasSchedules": Number(hasSchedules), 
            "hasTempSchedules": Number(hasTempSchedules),
            "activePinCount": Number(activePinCount),
            "sortAsc": Number(sortAsc),
            "sUserCount": Number(sUserCount), 
            "sCreated": Number(sCreated),
            "sFirmware": Number(sFirmware),
            "sName": Number(sName),
            "sCameraCount": Number(sCameraCount),
            "ruleV2Owner": Number(ruleV2Owner),
            "ruleV2Parent": Number(ruleV2Parent),
            "ruleV2Affected": Number(ruleV2Affected),
            "connectionIssues": Number(connectionIssues),
            "hasCamerasLinked": Number(hasCamerasLinked)
        }

        GetAllSites(body)
    }, [
        submit, 
        pageSize, 
        pageFetchedIndex, 
        online, 
        offline, 
        deviceTag, 
        cloudController, 
        davantis, 
        g2cc, 
        ESP, 
        RPi, 
        groupName, 
        includeSubgroups, 
        noTag, 
        active, 
        noUsers, 
        liveViewStatus, 
        scheduleOnly, 
        hasAjax, 
        hasHik, 
        hasAIBOX, 
        hasDahua, 
        hasPadlock, 
        hasKeybox, 
        hasSigfox, 
        hasIndSigfox, 
        hasEfento, 
        hasSchedules, 
        activePinCount, 
        sortAsc, 
        sUserCount, 
        sCreated, 
        sFirmware, 
        sName, 
        sCameraCount, 
        ruleV2Owner, 
        ruleV2Parent,
        ruleV2Affected, 
        connectionIssues, 
        hasCamerasLinked
        ]
    )

    useEffect(() => {
        const delay = setTimeout(() => {
            setSubmit(prev => !prev);
        }, 700); 

        //store it to reuse later
        dispatch(serviceActions.setSearchTerm(searchTerm))
      
        return () => clearTimeout(delay);
    }, [searchTerm]);

    const showError = (response) => {
        setTitle("Error")
        setModalComponent(
            <div>
                <div>
                    <h3 style={{ textAlign: "center" }}>Error</h3>
                </div>
                <div>
                    <p style={{ textAlign: "center" }}>{response.msg}</p>
                </div>
                <div style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "10px" // Adds space between buttons
                }}>
                    <Button1 onClick={HandleCloseModal}>Close</Button1>
                </div>
            </div>
        )

        HandleShowModal();
    }

    const navigateToGroup = () => {
        HandleCloseModal();
        navigate('/Dashboard/Groups/GroupSites')
    }

    const successModal = () => {
        setTitle('Success')
        setModalComponent(
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <img className={classes.ModalIcon} src={check}>
                </img>
                <br></br>
                <br></br>
                <div>
                    <h3 style={{ textAlign: "center", color: "#858585" }}>Action completed successfully</h3>
                </div>
                <br></br>
                <br></br>
                <div>
                    <br></br>
                    <Button1 onClick={navigateToGroup} style={{ width: "100%" }}>Take me there</Button1>
                </div>
            </div>
        )

        HandleShowModal();
    }

    const successModalAddUsers = (message) => {
        setTitle('Success')
        setModalComponent(
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <img className={classes.ModalIcon} src={check}>
                </img>
                <br></br>
                <br></br>
                <div>
                    <h3 style={{ textAlign: "center", color: "#858585" }}>{message}</h3>
                </div>
                <br></br>
                <br></br>
                <div>
                    <br></br>
                    <Button1 onClick={cancelAddAccess} style={{ width: "100%" }}>Close</Button1>
                </div>
            </div>
        )

        HandleShowModal();
    }

    const showLoadingModal = () => {
        setTitle('Please wait...')
        setModalComponent(
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <img className={classes.ModalIcon} src={loading}>
                </img>
                <br></br>
                <br></br>
                <div>
                    <h3 style={{ textAlign: "center", color: "#858585" }}>{"Adding user to selected sites..."}</h3>
                </div>
                <br></br>
                <br></br>
            </div>
        )
        HandleShowModal();
    }

    const AddSitesToGroup = async () => {
        let body = {
            groupID: sessionStorage.getItem('groupClickedID'),
            groupName: sessionStorage.getItem('groupClicked'),
            groupDevices: dataManager.getItem('selectedSites'),
        }
        console.log(body)
    

        const response = await addSitesToGroup(apiData, body, dispatch);

        if (response) {
            successModal();
            dataManager.setItem('isGroupMode', false);
            dataManager.setSelectedSites([]);
            setGroupMode(false);
        } else {
            //error
            showError(response.msg)
        }
    }

    const chooseRole = () => {
        setTitle("Choose role")
        setModalComponent(
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <h3>Choose a role for this user</h3>
                <p>Please note, this role will apply to ALL selected sites</p>
                <small>You can change this role later using the 'Change Role' feature available in the user sites dropdown menu</small>
                <br></br>
                <SelectRoleForm
                    setUserRole={setUserRole}
                    HandleCloseModal={HandleCloseModal}
                    HandleShowLoadingModal={showLoadingModal}
                    HandleAddUserSites={addSiteAccessForUser} />
                <Button1 onClick={HandleCloseModal}>Cancel</Button1>
            </div>
        )
        HandleShowModal();
    }

    const addSiteAccessForUser = async () => {
        const sitesToAdd = dataManager.getItem('selectedSites')
        console.log(sitesToAdd)
        if (sitesToAdd.length > 0) {
            let allSuccessful = true;
            let criticalError = false;
            let alreadyExists = false;
            let sitesUserWasAlreadyOn = []

            for (const site of sitesToAdd) {
                const { deviceID, deviceName } = site;
                const userToAddID = dataManager.getItem('clickedUserID');
                const role = dataManager.getItem('roleSelectedForUserInvite');
                const emailAddress = dataManager.getItem('clickedUserEmailAddress');

                const response = await inviteUser(apiData, deviceID, userID, role, emailAddress, deviceName, _companyName, dispatch);
                if (!response.success) {
                    allSuccessful = false;
                    if (response.msg === "Relationship already exists") {
                        sitesUserWasAlreadyOn.push(deviceID)
                        alreadyExists = true
                    } else {
                        errorModal("Something went wrong, please try again.");
                        criticalError = true
                        break;
                    }
                }
            }

            // If all were successful, show success and reset data
            if (allSuccessful) {
                HandleCloseModal();
                dataManager.setItem('addAccessMode', false)
                successModalAddUsers(`Successfully added to ${sitesToAdd.length} site(s)`);
                dataManager.setSelectedSites([]);
            } else if (!criticalError && alreadyExists) {
                HandleCloseModal();
                dataManager.setItem('addAccessMode', false)
                successModalAddUsers(`Successfully added to ${sitesToAdd.length - sitesUserWasAlreadyOn.length} site(s). \nUser already had access to ${sitesUserWasAlreadyOn.length} of the selected sites`);
                dataManager.setSelectedSites([]);
            } else if (criticalError) {
                errorModal("Something went wrong, please try again");
                dataManager.setSelectedSites([]);
                dataManager.setItem('addAccessMode', false)
            }
        } else {
            errorModal("Please select a site");
        }
    }

    const errorModal = (message) => {
        setTitle('Error')
        setModalComponent(
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <img className={classes.ModalIcon} src={fail}>
                </img>
                <br></br>
                <br></br>
                <div>
                    <h3 style={{ textAlign: "center", color: "#858585" }}>{message}</h3>
                </div>
                <br></br>
                <br></br>
                <div>
                    <br></br>
                    <Button1 style={{ width: "100%" }} onClick={HandleCloseModal}>Close</Button1>
                </div>
            </div>
        )
        HandleShowModal();
    }

    const cancel = () => {
        setGroupMode(false);
        dataManager.setItem('isGroupMode', false);
        dataManager.setSelectedSites([]);
        navigate('/Dashboard/Groups/GroupSites')
    }

    const cancelAddAccess = () => {
        dataManager.setItem('isAddAccessMode', false)
        dataManager.setSelectedSites([]);
        navigate('/Dashboard/Users/UserSites')
    }

    return (
        <>
            <Modal ref={ModalDialog} title={title} modalName={""} HandleShowModal={HandleShowModal}>
                {modalComponent}
            </Modal>

            <div className={classes.DeviceManagerPage}>
                <div className={classes.searchContainer}>

                    <AllSitesSearchBar
                        type="text"
                        placeholder="Search..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        showFilterButton={true}
                        groups={groups}
                        includeSubgroups={includeSubgroups}
                        setIncludeSubgroups={setIncludeSubgroups}
                        online={online}
                        setOnline={setOnline}
                        offline={offline}
                        setOffline={setOffline}
                        deviceTag={deviceTag}
                        setDeviceTag={setDeviceTag}
                        cloudController={cloudController}
                        setCloudController={setCloudController}
                        davantis={davantis}
                        setDavantis={setDavantis}
                        G2CC={g2cc}
                        setG2CC={setG2cc}
                        ESP={ESP}
                        setESP={setESP}
                        RPi={RPi}
                        setRPi={setRPi}
                        groupName={groupName}
                        setGroupName={setGroupName}
                        submit={submit}
                        setSubmit={setSubmit}
                        noTag={noTag}
                        setNoTag={setNoTag}
                        noUsers={noUsers}
                        setNoUsers={setNoUsers}
                        liveViewStatus={liveViewStatus}
                        setLiveViewStatus={setLiveViewStatus}
                        scheduleOnly={scheduleOnly}
                        setScheduleOnly={setScheduleOnly}
                        hasAjax={hasAjax}
                        setHasAjax={setHasAjax}
                        hasHik={hasHik}
                        setHasHik={setHasHik}
                        hasAIBOX={hasAIBOX}
                        setHasAIBOX={setHasAIBOX}
                        hasDahua={hasDahua}
                        setHasDahua={setHasDahua}
                        active={active}
                        setActive={setActive}
                        hasPadlock={hasPadlock}
                        setHasPadlock={setHasPadlock}
                        hasKeybox={hasKeybox}
                        setHasKeybox={setHasKeybox}
                        hasGateway={hasGateway}
                        setHasGateway={setHasGateway}
                        hasSigfox={hasSigfox}
                        setHasSigfox={setHasSigfox}
                        hasIndSigfox={hasIndSigfox}
                        setHasIndSigfox={setHasIndSigfox}
                        hasEfento={hasEfento}
                        setHasEfento={setHasEfento}
                        hasSchedule={hasSchedules}
                        setHasSchedule={setHasSchedules}
                        hasTempSchedules={hasTempSchedules}
                        setHasTempSchedules={setHasTempSchedules}
                        activePinCount={activePinCount}
                        setActivePinCount={setActivePinCount}
                        sortAsc={sortAsc}
                        setSortAsc={setSortAsc}
                        sUserCount={sUserCount}
                        setSUserCount={setSUserCount}
                        sCreated={sCreated}
                        setSCreated={setSCreated}
                        sFirmware={sFirmware}
                        setSFirmware={setSFirmware}
                        sName={sName}
                        setSName={setSName}
                        sCameraCount={sCameraCount}
                        setSCameraCount={setSCameraCount}
                        ruleV2Owner={ruleV2Owner}
                        setRuleV2Owner={setRuleV2Owner}
                        ruleV2Parent={ruleV2Parent}
                        setRuleV2Parent={setRuleV2Parent}
                        ruleV2Affected={ruleV2Affected}
                        setRuleV2Affected={setRuleV2Affected}
                        connectionIssues={connectionIssues}
                        setConnectionIssues={setConnectionIssues}
                        hasCamerasLinked={hasCamerasLinked}
                        setHasCamerasLinked={setHasCamerasLinked}
                        style={{
                            padding: "10px", 
                            width: "300px",    
                            fontSize: "14px",  
                            boxSizing: "border-box", 
                            borderRadius: "4px",
                        }}
                    />
                </div>

                <div className={classes.buttonContainer}>
                    {groupMode && <Button severity='success' style={{ fontSize: "14px", marginTop: "10px", padding:10 }} onClick={AddSitesToGroup} icon="pi pi-plus" label={`Add selected sites to ${sessionStorage.getItem('groupClicked')}`}/>}
                    {groupMode && <Button severity="danger" style={{ fontSize: "14px", marginTop: "10px", padding:10 }} onClick={cancel} icon="pi pi-times"label='Cancel' />}
                    {addAccessMode && <Button severity='success' style={{ fontSize: "14px", marginTop: "10px", padding:10 }} onClick={chooseRole}  icon="pi pi-plus" label='Add selected sites' />}
                    {addAccessMode && <Button severity='danger' style={{ fontSize: "14px", marginTop: "10px", padding:10 }} onClick={cancelAddAccess}  icon="pi pi-times" label='Cancel' />}

                </div>

                <div style={{ display: "flex", width: "100%", height: "10%", alignItems: "center" }}>
                    <p>Total results: {resultCount}</p>
                </div>

                
                    <Await resolve={filteredData}>
                        {(loadedFilteredData) => (
                            <div style={{ display: "flex", width: "100%", height: "100%" }}>
                                {isloading ? (
                                    <div style={{ display: "flex", width: "100%" }}>
                                        <DeviceLoadingGrid
                                            CardCount={20}
                                        />
                                    </div>
                                ) : (                                 
                                        <DevicesList
                                            devices={loadedFilteredData}
                                            filtering={""}
                                            hideControls={false}
                                            totalPages={totalPages}
                                            setTotalPages={setTotalPages}
                                            pageFetchedIndex={pageFetchedIndex}
                                            setPageFetchedIndex={setPageFetchedIndex}
                                            pageSize={pageSize}
                                            setPageSize={setPageSize}
                                            totalDevices={resultCount}
                                            setTotalDevices={setTotalDevices}
                                            groupMode={groupMode}
                                            update={update}
                                            setUpdate={setUpdate}
                                            offlineOnly={false}
                                            isSortable={true}
                                            showMassSelect={true}
                                            showMassSettings={showMassSettings}
                                            setShowMassSettings={setShowMassSettings}
                                        />
                                    ) 
                                }
                            </div>
                        )}
                    </Await>
               
            </div>
        </>
    )
}

export default DeviceManager